import { Referral } from "@/src/models/documents/referral";

export const ENTP_SCI_ECW_LOGIN_URL = "https://ilspciapp.eclinicalweb.com/mobiledoc/jsp/webemr/login/newLogin.jsp";

export const ENTP_SCI_NCH_NEUROSCIENCES_SYNC = {
  assignee: "Strom, Talita",
  ghossainiNpi: "1104962661",
  locationNamePattern: "nch neurosciences",
  address: {
    line1Tokens: ["880", "central"],
    city: "arlington heights",
  },
} as const;

export function isEntpSciNchNeurosciencesSyncReferral(referral: Referral): boolean {
  const providerNpi = referral.referringProvider?.npiNumber;

  if (providerNpi === ENTP_SCI_NCH_NEUROSCIENCES_SYNC.ghossainiNpi) return true;

  const locationName = referral.referringLocation?.name?.toLowerCase() ?? "";
  const addressLine1 = referral.referringLocation?.address?.line1?.toLowerCase() ?? "";
  const city = referral.referringLocation?.address?.city?.toLowerCase() ?? "";
  const { line1Tokens, city: cityPattern } = ENTP_SCI_NCH_NEUROSCIENCES_SYNC.address;

  return (
    locationName.includes(ENTP_SCI_NCH_NEUROSCIENCES_SYNC.locationNamePattern) ||
    (line1Tokens.every((token) => addressLine1.includes(token)) && city.includes(cityPattern))
  );
}
